import { Button as MuiButton } from '@mui/material'
import React from 'react'

type ButtonSecondaryProps = {
  startIcon?: React.ReactNode
  onClick: () => void
  disabled?: boolean
  label: string
  maxWidth?: number
  maxHeight?: number
}

export const ButtonSecondary: React.FC<ButtonSecondaryProps> = ({
  startIcon,
  onClick,
  disabled,
  label,
  maxWidth,
  maxHeight,
}) => {
  return (
    <MuiButton
      startIcon={startIcon}
      onClick={onClick}
      variant='contained'
      color='secondary'
      disabled={disabled}
      sx={{
        pl: 2,
        pr: 2,
        maxWidth: maxWidth ? `${maxWidth}px` : undefined,
        maxHeight: maxHeight ? `${maxHeight}px` : undefined,
      }}
    >
      {label}
    </MuiButton>
  )
}
